import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";

function App() {
  const [currentPage, setCurrentPage] = useState("home");

  // Scroll to top on page transition
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <Home setCurrentPage={setCurrentPage} />;
      case "about":
        return <About />;
      case "contact":
        return <Contact />;
      case "privacy":
        return <Privacy />;
      default:
        return <Home setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      {/* Background Cyber Infrastructure Grid */}
      <div className="cyber-grid" />
      
      <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      
      <main style={{ position: "relative", zIndex: 1, paddingBottom: "60px" }}>
        {renderPage()}
      </main>
      
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
}

export default App;